import { GuaranteeFormValues, isGuaranteePresent } from 'features/declaration/models/schemas/guaranteeSchema'
import { excludeDeleted } from 'shared/lib/common-util'
import { Guarantee } from '../models/types'
import { toGuaranteeUpdates } from '../models/mapper'
import { createGuarantees } from '../api/createGuarantees'
import { createDraftGuarantees } from '../api/createDraftGuarantees'
import { updateGuarantees } from '../api/updateGuarantees'
import { updateDraftGuarantees } from '../api/updateDraftGuarantees'
import { ErrorResult } from '../../../../shared/models/types'
import { BadRequestResponse } from '../../../../types/Errors'

function useSaveGuaranteeFormValues() {
  const saveGuarantees = async (
    transitOperationId: number,
    guaranteeFormValues: GuaranteeFormValues[],
    isDraft: boolean,
  ) => {
    let saved: Guarantee[] = []
    const errors: ErrorResult[] = []
    const formValues = guaranteeFormValues
      .filter(excludeDeleted)
      .filter(isGuaranteePresent)
    if (!formValues.length) return { saved, errors }

    const updates = toGuaranteeUpdates(transitOperationId, formValues)
    const createRequests = []
    const updateRequests = []
    for (const update of updates) {
      if (update.id != null) {
        updateRequests.push(update)
      } else {
        createRequests.push(update)
      }
    }

    const createGuaranteesFn = isDraft ? createDraftGuarantees : createGuarantees
    const updateGuaranteesFn = isDraft ? updateDraftGuarantees : updateGuarantees

    const requests = []
    if (createRequests.length) {
      requests.push(createGuaranteesFn(createRequests))
    }
    if (updateRequests.length) {
      requests.push(updateGuaranteesFn(updateRequests))
    }

    if (!requests.length) {
      return { saved: [], errors: [] }
    }

    const settledGuaranteePromises = await Promise.allSettled(requests)

    const rejectedDocumentPromises = settledGuaranteePromises.filter((result): result is PromiseRejectedResult => result.status === 'rejected')
    rejectedDocumentPromises.forEach((result) => {
      const errorResponseData = result.reason?.response?.data
      if (errorResponseData?.message === 'CONSTRAINT_VIOLATION') {
        errorResponseData?.errors.forEach((errorItem: BadRequestResponse) => {
          errors.push({
            message: errorResponseData.message,
            field: errorItem.field,
            code: errorItem.reason,
          })
        })
      }
    })

    saved = settledGuaranteePromises.filter((promise): promise is PromiseFulfilledResult<Guarantee[]> => promise.status !== 'rejected')
      .flatMap((promise) => promise.value)

    return {
      saved,
      errors,
    }
  }

  return {
    saveGuarantees,
  }
}

export default useSaveGuaranteeFormValues
